/* Vanthe: hero de compra de la home.

   - Slides estaticos: el slide activo solo cambia cuando el visitante elige
     un color (logica en la propia seccion). Sin rotacion automatica.
   - Fija --vhero-top (barra de anuncio + cabecera) para el above-the-fold.
   - Selector de variante por chaqueta: LLEVA 1 configura 1 chaqueta; PACK 2
     muestra dos bloques y permite combinar variantes distintas.
   - Comprar: resuelve las variantes y las anade con /cart/add.js (items),
     luego navega a return_to. Con 2 variantes iguales se manda una linea de
     cantidad 2; con distintas, dos lineas de 1. */
(function () {
  'use strict';

  function setTopVar() {
    var groups = document.querySelectorAll('.shopify-section-group-header-group, #shopify-section-header, [id*="__header"], [id*="announcement-bar"], [id*="marquesina"]');
    var maxBottom = 0;
    groups.forEach(function (g) {
      var r = g.getBoundingClientRect();
      if (r.height && r.bottom > maxBottom) maxBottom = r.bottom;
    });
    if (maxBottom > 0) document.documentElement.style.setProperty('--vhero-top', Math.round(maxBottom) + 'px');
  }

  function initBuy(root) {
    var form = root.querySelector('[data-vhero-form]');
    if (!form) return;
    var cta = form.querySelector('[data-vhero-cta]');
    var ui = root.querySelector('[data-vhero-variants-ui]');
    var dataEl = root.querySelector('[data-vhero-variants]');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) {}

    function sameOpts(a, b) {
      if (a.length !== b.length) return false;
      for (var k = 0; k < a.length; k++) { if (a[k] !== b[k]) return false; }
      return true;
    }

    // Resuelve el variant id de un bloque de chaqueta (1 o 2)
    function resolveVariant(chq) {
      var block = root.querySelector('.vhero__chq[data-chaqueta="' + chq + '"]');
      if (!block) return null;
      var chosen = [];
      block.querySelectorAll('.vhero__opt').forEach(function (o) {
        var r = o.querySelector('input[type=radio]:checked');
        chosen.push(r ? r.value : null);
      });
      var m = variants.find(function (v) { return sameOpts(v.opts, chosen); });
      return m || null;
    }

    // Marca visualmente la seleccion de swatches
    root.querySelectorAll('.vhero__swatch input').forEach(function (r) {
      r.addEventListener('change', function () {
        var group = r.closest('.vhero__swatches');
        group.querySelectorAll('.vhero__swatch').forEach(function (s) {
          s.classList.toggle('is-active', s.contains(r));
        });
      });
    });

    // Tarjetas de oferta -> modo (1 chaqueta o 2)
    var cards = root.querySelectorAll('.vhero__card');
    function selectCard(card) {
      cards.forEach(function (c) { c.classList.toggle('is-selected', c === card); });
      ui.setAttribute('data-mode', card.getAttribute('data-qty'));
    }
    cards.forEach(function (card) {
      var radio = card.querySelector('.vhero__radio');
      card.addEventListener('click', function () { radio.checked = true; selectCard(card); });
      radio.addEventListener('change', function () { if (radio.checked) selectCard(card); });
    });
    var pre = root.querySelector('.vhero__radio:checked');
    if (pre) selectCard(pre.closest('.vhero__card'));

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var mode = ui.getAttribute('data-mode');
      var v1 = resolveVariant(1);
      if (!v1) { alert('Elige talla y color de la Chaqueta 1.'); return; }

      var items;
      if (mode === '2') {
        var v2 = resolveVariant(2);
        if (!v2) { alert('Elige talla y color de la Chaqueta 2.'); return; }
        if (v1.id === v2.id) {
          items = [{ id: v1.id, quantity: 2 }];
        } else {
          items = [{ id: v1.id, quantity: 1 }, { id: v2.id, quantity: 1 }];
        }
      } else {
        items = [{ id: v1.id, quantity: 1 }];
      }

      cta.classList.add('is-loading');
      var dest = (form.querySelector('[data-vhero-return]') || {}).value || '/cart';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) {
            cta.classList.remove('is-loading');
            alert((res.j && res.j.description) || 'No se pudo anadir al carrito.');
            return;
          }
          window.location.href = dest;
        })
        .catch(function () { cta.classList.remove('is-loading'); alert('No se pudo anadir al carrito. Intentalo de nuevo.'); });
    });
  }

  function boot() {
    setTopVar();
    document.querySelectorAll('[data-vhero]').forEach(function (root) {
      initBuy(root);
    });
  }

  window.addEventListener('resize', setTopVar);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
